import React, { useEffect, Component } from 'react';
import { useLocation } from 'react-router-dom';

// function ScrollToTop(props) {
//   const location = useLocation();
//   const onProducts =
//     location.pathname.startsWith('/products/') ||
//     location.pathname.startsWith('/v3/products/');

//   useEffect(() => {
//     if (!onProducts) window.scrollTo(0, 0);
//   }, [location.pathname, onProducts]);

//   return props.children;
// }

// export default ScrollToTop;

function PassLocation(props) {
  const location = useLocation();
  return <ScrollToTop location={location}>{props.children}</ScrollToTop>;
}

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname.startsWith('/products/') &&
      prevProps.location.pathname.startsWith('/products/')
    ) {
      return;
    }
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default PassLocation;
